













































import Vue from 'vue';
import Example from './components/Example.vue';

export default Vue.extend({
  name: 'App',

  components: {
    Example,
  },

  data: () => ({
    //
  }),
});
